import * as msgService from '../../services/msg.service';


const state = {
    newMsgs:{},
};

const getters = {
    getNewMsgs:state => (state.newMsgs),
};

const actions = {
    // Get New messages
    async fetchNewMsgs({ commit }, obj){
        try {
            const response = await msgService.getNewMsgs(obj);
            commit('setNewMsgs', response.data.data);
            
        } catch (error) {
            console.log('fetchNewMsgs', error);
        }
    },
};

const mutations = {
    setNewMsgs:(state, res) => (
        state.newMsgs =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}